module.exports = __webpack_public_path__ + "img/venue visits light.a75f594b.png";